(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('luxury-video-hero')) {
  customElements.define('luxury-video-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.userPaused = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.playButton = this.querySelector('[data-play]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.querySelector('.banner-controls').hidden = !this.slides.length;
      this.prevButton.disabled = this.nextButton.disabled = this.slides.length < 2;
      this.playButton.addEventListener('click', () => {
        const video = this.video();
        if (!video) return;
        if (video.paused) { this.userPaused = false; this.play(); }
        else { this.userPaused = true; video.pause(); }
      }, options);
      this.prevButton.addEventListener('click', () => this.show(this.index - 1, true), options);
      this.nextButton.addEventListener('click', () => this.show(this.index + 1, true), options);
      this.slides.forEach(slide => {
        const video = slide.querySelector('video');
        if (!video) return;
        video.autoplay = false; video.pause();
        video.muted = true; video.loop = true; video.playsInline = true;
        ['play','pause','error'].forEach(event => video.addEventListener(event, () => this.sync(), options));
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video()?.pause(); else this.resume();
      }, options);
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.video()?.pause(); else this.resume();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (!this.inView) this.video()?.pause(); else this.resume();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) this.show(index, false);
      }, options);
      this.show(0, false);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect();
      this.slides?.forEach(slide => slide.querySelector('video')?.pause());
    }
    video() { return this.slides[this.index]?.querySelector('video'); }
    show(index, announce) {
      if (!this.slides.length) return;
      this.slides.forEach(slide => { slide.querySelector('video')?.pause(); slide.hidden = true; });
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides[this.index].hidden = false;
      this.sync(); this.resume();
      if (announce) this.querySelector('.hero-banner__status').textContent = `Video ${this.index + 1} von ${this.slides.length}`;
    }
    resume() {
      if (this.inView && !document.hidden && !this.userPaused && !this.reduced.matches) this.play();
    }
    async play() {
      const video = this.video();
      if (!video) return;
      try { await video.play(); } catch { /* Keep poster and manual play available if autoplay is blocked. */ }
      this.sync();
    }
    sync() {
      const video = this.video();
      const playing = !!video && !video.paused;
      this.playButton.disabled = !video || !!video.error;
      this.playButton.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
      this.playButton.setAttribute('aria-pressed', String(playing));
      this.querySelector('[data-play-icon]').textContent = playing ? 'Ⅱ' : '▶';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
